/**
 * Rounds the number to 2 decimals
 */
export default function roundToTwoDecimals(num: number): number {
    return Math.round(num * 100 + Number.EPSILON) / 100
}